export const thoughtspotMetricsStyles = {
  style: {
    customCSS: {
      rules_UNSTABLE: {
        html: {
          'font-family': 'Inter, sans-serif !important',
          'font-feature-settings': 'normal !important',
        },
        '.embed-module__tsEmbedContainer': {
          height: '32px !important',
          'min-height': '32px !important',
          border: 'none !important',
          'background-color': 'transparent !important',
        },
        '.authenticated-app-view-module__blink': {
          height: '32px !important',
          'min-height': '32px !important',
          border: 'none !important',
          'background-color': 'transparent !important',
        },
        '.kpi-module__sparkline': {
          display: 'none !important',
        },
        '.answer-title-module__descriptionTextOneLine': {
          display: 'none',
        },
        '.pinboard-header-module__pinboardHeaderContainer': {
          display: 'none !important',
        },
        '.kpi-module__sublabel': {
          display: 'none',
        },
        '.kpi-module__baseValueLabel': {
          display: 'none',
        },
        '.kpi-module__timeBucket': {
          display: 'none',
        },
        '.answer-title-module__titleText': {
          'font-size': '11px !important',
          'line-height': '16px !important',
          'font-weight': '500 !important',
          color: '#605F6B !important',
          'min-height': '14px !important',
          height: '14px !important',
          padding: '0 !important',
        },
        '.kpi-module__hero': {
          'font-size': '24px !important',
          'line-height': '32px !important',
          'font-weight': '700 !important',
          color: '#42414E !important',
          height: 'auto !important',
          display: 'flex !important',
          flex: '1 !important',
        },
        '.kpi_comparision_diff': {
          'font-size': '13px !important',
          'font-family': 'Inter, sans-serif',
          height: 'auto !important',
        },
        '.kpi-module__arrowUp': {
          width: '20px !important',
          height: '20px !important',
        },
        '.react-grid-layout': {
          display: 'flex !important',
          flex: '1 !important',
          position: 'static !important',
          height: '32px !important',
          'max-height': '32px !important',
          gap: '16px !important',
        },
        '.react-grid-item': {
          display: 'inline-block !important',
          flex: '1 !important',
          position: 'static !important',
          transform: 'none !important',
          height: '32px !important',
          'max-height': '32px !important',
        },
        '.answer-content-header-module__container': {
          height: 'auto !important',
          'max-height': '26px !important',
        },
        '.kpi-module__sublabelWrapper': {
          display: 'none !important',
        },
        '.kpi-module__kpi': {
          'flex-direction': 'row !important',
          'align-items': 'end',
        },
        '.kpi-module__heroDataContainer': {
          display: 'flex !important',
          flex: '1 !important',
        },
        '.rd-tooltip': {
          display: 'none !important',
        },
        '.answer-content-module__answerVizContainer': {
          border: 'none !important',
          'background-color': 'transparent !important',
          padding: '0 !important',
        },
        '.answer-content-header-module__compactContainer': {
          border: 'none !important',
          'background-color': 'transparent !important',
          'padding-bottom': '0 !important',
        },
        '.kpi-module__heroMeasure': {
          'padding-top': '0 !important',
        },
        '.answer-content-module__verticalLayoutContainer': {
          display: 'none !important',
        },
      },
    },
  },
};
